'use client';
import { Booking, Order } from '@shared/types';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import { AccessOrderButton } from './components/AccessOrderButton';
import { ViewMyBookingButton } from './components/ViewMyBookingButton';

type EnrolledAccessButtonProps = {
    course: PublicCourse;
    educatorSlug: PublicEducator['slug'];
    enrolmentId?: Booking['_id'] | Order['_id'] | null;
};

export const EnrolledAccessButton: FunctionComponent<EnrolledAccessButtonProps> = ({
    course,
    educatorSlug,
    enrolmentId,
}) => {
    if (!enrolmentId) {
        return null;
    }

    if (course.type === 'on-demand') {
        return (
            <AccessOrderButton
                courseKeyword={course.keyword}
                courseSlug={course.slug}
                educatorSlug={educatorSlug}
                orderId={enrolmentId}
            />
        );
    }

    return (
        <ViewMyBookingButton
            bookingId={enrolmentId}
            courseSlug={course.slug}
            educatorSlug={educatorSlug}
        />
    );
};
